"use client";
import PropTypes from "prop-types";

/* import sponsoredCompaniesItems from "mock/sponsored-companies-items"; */

import Showcase from "components/homepage/showcase";
import HighlighterTabs from "components/homepage/highlighter-tabs";
import { PlatinumListing } from "src/components/homepage/platinum-listing/PlatinumListing";
import { RealEstateSolutions } from "components/homepage/real-estate-solutions/RealEstateSolutions";
/* import SponsoredCompany from "components/homepage/sponsored-company"; */
import MobileAppBanner from "components/mobile-app-banner";
import FrequentlyWords from "components/homepage/frequently-words";
import InitialPageLoadGtmEvent from "components/gtm-load-events/initialPageLoadEvents";
import NewsList from "components/homepage/news-list";
import CyprusBanner from "@/src/components/homepage/cyprus-banner";

const HomeScreen = ({ pageResponse }) => {
  const { news, categoryTree, platinumListings, allHighlighterTabListingInfo, lastView } = pageResponse;
  const isHavePlatinumListing = platinumListings?.listingCard?.total > 0;

  return (
    <>
      <InitialPageLoadGtmEvent pageNameForSearchId="homepage" pageType="ana-sayfa" />
      <div id="content-wrapper">
        <Showcase categoryTree={categoryTree} />
        <HighlighterTabs allHighlighterTabListingInfo={allHighlighterTabListingInfo} lastView={lastView} />
        <CyprusBanner />
        {isHavePlatinumListing && <PlatinumListing platinumListings={platinumListings} />}
        <RealEstateSolutions />
        {/* {sponsoredCompaniesItems.length && <SponsoredCompany data={sponsoredCompaniesItems} />} */}
        <NewsList data={news} />
        <MobileAppBanner />
        <FrequentlyWords />
      </div>
    </>
  );
};

HomeScreen.propTypes = {
  pageResponse: PropTypes.object,
};

export default HomeScreen;
